import { commonHelpers } from 'helpers/commonHelper';
import { dateHelper } from 'helpers/dateHelper';
import { getTableHeightFitContent } from 'helpers/lib/reactDataGridHelpers';
import { get } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import ReactDataGrid from 'react-data-grid';

const EmptyRowsView = () => {
    const message = 'Chưa có mục chi nào';
    return (
        <div style={{ textAlign: 'center', backgroundColor: '#ddd', padding: '100px' }}>
            <h3>{message}</h3>
        </div>
    );
};

function DuChiCongDoanTable({ academicYear, danhmucchicongdoans, duchicongdoans, data, setData }) {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const numOfMonthForYear = get(academicYear, 'congDoanNumOfMonth', 12);
    const congDoanStartMonth = get(academicYear, 'congDoanStartMonth', 5);

    const [tableHeight, setTableHeight] = useState();
    useEffect(() => {
        setTableHeight(getTableHeightFitContent());
    }, []);

    useEffect(() => {
        const rows = [];
        if (danhmucchicongdoans) {
            danhmucchicongdoans
                .sort((a, b) => a.code - b.code)
                .forEach((dm) => {
                    const matchedDuChiCongDoan = duchicongdoans ? duchicongdoans.find((duthu) => dm.code === duthu.danhMucChiCongDoanCode) : {};
                    const row = {
                        dmId: dm.id,
                        code: dm.code,
                        name: dm.name,
                        id: get(matchedDuChiCongDoan, 'id'),
                        danhMucChiCongDoanCode: get(matchedDuChiCongDoan, 'danhMucChiCongDoanCode'),
                        junAmount: get(matchedDuChiCongDoan, 'junAmount', '') ? get(matchedDuChiCongDoan, 'junAmount') : '',
                        julAmount: get(matchedDuChiCongDoan, 'julAmount', '') ? get(matchedDuChiCongDoan, 'julAmount') : '',
                        augAmount: get(matchedDuChiCongDoan, 'augAmount', '') ? get(matchedDuChiCongDoan, 'augAmount') : '',
                        sepAmount: get(matchedDuChiCongDoan, 'sepAmount', '') ? get(matchedDuChiCongDoan, 'sepAmount') : '',
                        octAmount: get(matchedDuChiCongDoan, 'octAmount', '') ? get(matchedDuChiCongDoan, 'octAmount') : '',
                        novAmount: get(matchedDuChiCongDoan, 'novAmount', '') ? get(matchedDuChiCongDoan, 'novAmount') : '',
                        decAmount: get(matchedDuChiCongDoan, 'decAmount', '') ? get(matchedDuChiCongDoan, 'decAmount') : '',
                        janAmount: get(matchedDuChiCongDoan, 'janAmount', '') ? get(matchedDuChiCongDoan, 'janAmount') : '',
                        febAmount: get(matchedDuChiCongDoan, 'febAmount', '') ? get(matchedDuChiCongDoan, 'febAmount') : '',
                        marAmount: get(matchedDuChiCongDoan, 'marAmount', '') ? get(matchedDuChiCongDoan, 'marAmount') : '',
                        aprAmount: get(matchedDuChiCongDoan, 'aprAmount', '') ? get(matchedDuChiCongDoan, 'aprAmount') : '',
                        mayAmount: get(matchedDuChiCongDoan, 'mayAmount', '') ? get(matchedDuChiCongDoan, 'mayAmount') : '',
                        extraAmount1: get(matchedDuChiCongDoan, 'extraAmount1', '') ? get(matchedDuChiCongDoan, 'extraAmount1', '') : '',
                        extraAmount2: get(matchedDuChiCongDoan, 'extraAmount2', '') ? get(matchedDuChiCongDoan, 'extraAmount2', '') : '',
                        duchi: matchedDuChiCongDoan,
                    };
                    rows.push(row);
                });
            setRows(rows);
        }
    }, [duchicongdoans, danhmucchicongdoans]);

    const buildDynamicColumnBaseOnYear = useCallback(() => {
        const isEditable = commonHelpers.ableToPersitDuThuChi(academicYear.name);
        const fieldMap = dateHelper.duThuFieldMappedByMonth();
        const extraKeys = ['extraAmount1', 'extraAmount2'];

        const columns = [];
        for (let i = 0; i < numOfMonthForYear; i++) {
            const position = i + 1;
            const month = ((congDoanStartMonth - 1 + i) % 12) + 1;
            const key = position <= 12 ? fieldMap.get(month) : extraKeys[position - 13];
            columns.push({ key, name: `Tháng ${month}`, editable: isEditable, width: 80 });
        }
        return columns;
    }, [numOfMonthForYear, congDoanStartMonth]);

    useEffect(() => {
        const commonColumns = [
            { key: 'code', name: 'Mã số', editable: false, width: 60 },
            { key: 'name', name: 'Diễn giải', editable: false, width: 360 },
        ];
        const dynamicColumns = buildDynamicColumnBaseOnYear();
        const columns = [...commonColumns, ...dynamicColumns].map((item) => {
            return { ...item, ...{ resizable: true } };
        });
        setColumns(columns);
    }, [buildDynamicColumnBaseOnYear]);

    const onGridRowsUpdated = ({ fromRow, toRow, updated, cellKey }) => {
        const newData = new Map(data);
        const newRows = [...rows];
        for (let i = fromRow; i <= toRow; i++) {
            newRows[i] = { ...newRows[i], ...updated };
            if (get(newRows[i], 'dm.id', false) || updated[cellKey] !== '') {
                newData.set(i, newRows[i]);
            }
        }
        setRows(newRows);
        setData(newRows);
    };

    return (
        <div id="rdg">
            <ReactDataGrid
                columns={columns}
                rowGetter={(i) => rows[i]}
                rowsCount={rows.length}
                minHeight={tableHeight}
                enableCellSelect={true}
                onGridRowsUpdated={onGridRowsUpdated}
                emptyRowsView={EmptyRowsView}
            />
        </div>
    );
}

export default DuChiCongDoanTable;
